export const IsQuestionRequiredError = (
  question,
  values,
  questionIsPercentGroupSection
) => {
  return questionIsPercentGroupSection
    ? checkPercentGroupRequired(question, values)
    : question.answers[0].answerType === 'PercentInput' &&
      question.answers.length === 1
    ? checkPercentRequired(question, values)
    : checkQuestionRequired(question, values)
}

export const IsQuestionInvalidError = (
  question,
  values,
  questionIsPercentGroupSection,
  firstPercentGroupComplete
) => {
  return questionIsPercentGroupSection
    ? checkPercentGroupValidation(question, values, firstPercentGroupComplete)
    : isValueInvalid(question, values)
}

export const QuestionHasTooManyAnswers = (question, values) =>
  !!question.maxNumberOfAnswers &&
  values?.[question.id]?.length > question.maxNumberOfAnswers

export const isAnswerInvalid = (
  question,
  values,
  questionIsPercentGroupSection,
  firstPercentGroupComplete
) => {
  if (question.questionType === 'marketing-matrix') {
    if (!MarketingMatrixQuestionIsVisible(question, values)) {
      return false
    }
  }
  if (
    question.questionType !== 'marketing-matrix' &&
    !QuestionVisible(question, values)
  ) {
    return false
  }

  const requiredError = IsQuestionRequiredError(
    question,
    values,
    questionIsPercentGroupSection
  )
  const invalidError = IsQuestionInvalidError(
    question,
    values,
    questionIsPercentGroupSection,
    firstPercentGroupComplete
  )
  const tooManyAnswersError = QuestionHasTooManyAnswers(question, values)
  return requiredError || invalidError || tooManyAnswersError
}

//Expected format of contents of hideTrigger field of a question
//whose visibility is controlled by the answers to another question
//parentQuestionId1-answerId1,..,answerId3|parentQuestionId2-answerId4,...,answerId6
export const QuestionVisible = (question, values) => {
  if (question.hideTrigger != null && question.hideTrigger != 'undefined') {
    var hideAnswerSets = question.hideTrigger.split('|')
    for (let answerSet of hideAnswerSets) {
      var answerSetParts = answerSet.split('-')
      if (answerSetParts.length == 2) {
        var parentQuestionId = answerSetParts[0]
        var hideAnswers = answerSetParts[1].split(',')
        if (hideAnswers.includes(values[parentQuestionId])) {
          return false
        }
      }
    }
  }
  return true
}

export const MarketingMatrixQuestionIsVisible = (question, values) => {
  if (question.hideTrigger != null && question.hideTrigger != 'undefined') {
    const hideAnswerSets = question.hideTrigger.split('|')
    return hideAnswerSets.every(answerSet => {
      const answerSetParts = answerSet.split('-')
      if (answerSetParts.length == 2) {
        const parentQuestionId = answerSetParts[0]
        const hideAnswers = answerSetParts[1].split(',')
        const triggerValues = values[parentQuestionId]
        const isArr = triggerValues && Array.isArray(triggerValues)
        const containsSome =
          isArr &&
          triggerValues &&
          triggerValues.some(element => {
            return hideAnswers.includes(element)
          })
        if (containsSome) {
          return true
        } else if (hideAnswers.includes(values[parentQuestionId])) {
          return true
        }
      }
    })
  }
  return true
}

const checkQuestionRequired = (question, values) => {
  //required answer is not answered returns true
  if (question) {
    const requiredError =
      question.requiredNumberOfAnswers > 0
        ? values[question.id] !== undefined
          ? values[question.id].length < question.requiredNumberOfAnswers
          : !values[question.id]
        : false
    return requiredError
  }
  return false
}

const isValueInvalid = (question, values) => {
  const passSpecialValidation = question?.validation?.specialFormat
    ? CheckSpecialValidation(
        question.validation.specialFormat,
        values[question.id]
      )
    : true
  return !passSpecialValidation
}

export const ShowInvalidErrorMessage = (question, values) => {
  if (isValueInvalid(question, values)) {
    return getValidationMessageByType(question?.validation?.specialFormat)
  }
}

const checkPercentGroupRequired = (question, values) => {
  let numOfAnswerCurrent = 0
  let numOfAnswerFuture = 0
  question.answers.forEach(answer => {
    if (values[answer.id]) {
      if (answer.groupId === 1) {
        numOfAnswerCurrent++
      }
      if (answer.groupId === 2) {
        numOfAnswerFuture++
      }
    }
  })
  const requiredError =
    numOfAnswerCurrent + numOfAnswerFuture < question.requiredNumberOfAnswers
  return requiredError
}

const checkPercentRequired = (question, values) => {
  if (question.requiredNumberOfAnswers > 0) {
    const requiredError = values[question.answers[0].id] === undefined
    return requiredError
  }
  return false
}

const checkPercentGroupValidation = (
  question,
  values,
  firstPercentGroupComplete
) => {
  let numOfAnswerCurrent = 0
  let numOfAnswerFuture = 0
  let currentTotal = 0
  let futureTotal = 0
  question.answers.forEach(answer => {
    if (values[answer.id]) {
      if (answer.groupId === 1) {
        numOfAnswerCurrent++
        currentTotal =
          currentTotal +
          parseInt(values[answer.id].substring(0, values[answer.id].length))
      }
      if (answer.groupId === 2) {
        numOfAnswerFuture++
        futureTotal =
          futureTotal +
          parseInt(values[answer.id].substring(0, values[answer.id].length))
      }
    }
  })
  const invalidError = firstPercentGroupComplete
    ? numOfAnswerFuture !== 0 && futureTotal !== 100
    : numOfAnswerCurrent !== 0 && currentTotal !== 100

  return invalidError
}

export const CheckSpecialValidation = (specialFormat, value) => {
  if (specialFormat === 'email') {
    return validateEmail(value)
  } else if (specialFormat === 'alphanumeric') {
    return validateAlphaNumeric(value)
  }
  return true
}

const getValidationMessageByType = specialFormat => {
  if (specialFormat === 'email') {
    return SPECIAL_ERROR_MESSAGE.EMAIL
  } else if (specialFormat === 'alphanumeric') {
    return SPECIAL_ERROR_MESSAGE.ALPHANUMERIC
  }
}

const validateEmail = value => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(value)
}

const validateAlphaNumeric = value => {
  return /^[A-Z0-9a-z]+$/i.test(value)
}

const SPECIAL_ERROR_MESSAGE = {
  EMAIL: 'Must be a valid email address.',
  ALPHANUMERIC: 'Must contain only letters and numbers.',
}
